import React from 'react';
import {createStackNavigator} from '@react-navigation/stack';
import SettingsView from '../components/settings/settings';
import DevicesScreen from '../components/settings/devices';
import DatabasesScreen from '../components/settings/databases';
import PremiumScreen from '../components/settings/premium';
import {SettingsStackParams} from '../types/nav';

const RenderSettings = (props: any) => <SettingsView {...props} />;
const Devices = (props: any) => <DevicesScreen {...props} />;
const Databases = (props: any) => <DatabasesScreen {...props} />;

const SettingsStack = createStackNavigator<SettingsStackParams>();

export const createSettings = () => {
  const SettingsStackScreen = () => {
    return (
      <SettingsStack.Navigator
        screenOptions={{
          headerShown: false,
          freezeOnBlur: true,
        }}>
        <SettingsStack.Screen
          name="Settings"
          component={RenderSettings}
        />
        <SettingsStack.Screen
          name="Devices"
          component={DevicesScreen}
        />
        <SettingsStack.Screen
          name="Premium"
          component={PremiumScreen}
        />
        {/* <SettingsStack.Screen name="Drive" component={Devices} /> */}
        <SettingsStack.Screen
          name="Databases"
          component={Databases}
        />
      </SettingsStack.Navigator>
    );
  };
  return SettingsStackScreen;
};
